import api from './index'

export function widgetCreate(widgetData, params = {}) {
  return api.post('widgets/', widgetData, { params })
}

export function widgetSave(widgetId, widgetData, params = {}) {
  return api.put(`widgets/${widgetId}/`, widgetData, { params })
}
